
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';

/**
 * OrderStateSubscribeResponse struct
 */
class OrderStateSubscribeResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!UUID=} subscriptionId
   * @param {!Array=} orderIds
   * @constructor
   */
  constructor (parent = new Response(), subscriptionId = new UUID(), orderIds = []) {
    super()
    super.copy(parent)
    this.SubscriptionId = subscriptionId
    this.OrderIds = orderIds
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderStateSubscribeResponse}
   * @param {!OrderStateSubscribeResponse} other Other struct
   * @returns {!OrderStateSubscribeResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SubscriptionId != null) {
      this.SubscriptionId = new UUID(other.SubscriptionId)
    } else {
      this.SubscriptionId = null
    }
    if (other.OrderIds != null) {
      this.OrderIds = []
      for (let item of other.OrderIds) {
        if (item != null) {
          let tempItem
          tempItem = UInt64.fromNumber(item)
          this.OrderIds.push(tempItem)
        } else {
          this.OrderIds.push(null)
        }
      }
    } else {
      this.OrderIds = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderStateSubscribeResponse}
   * @returns {!OrderStateSubscribeResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderStateSubscribeResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderStateSubscribeResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderStateSubscribeResponse}
   * @param {!OrderStateSubscribeResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderStateSubscribeResponse)) {
      throw new TypeError('Instance of OrderStateSubscribeResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderStateSubscribeResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SubscriptionId: ((this.SubscriptionId != null) ? this.SubscriptionId.toString() : null),
      OrderIds: ((this.OrderIds != null) ? Array.from(this.OrderIds, item => ((item != null) ? item.toNumber() : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderStateSubscribeResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderStateSubscribeResponse} other Object value
   * @returns {!OrderStateSubscribeResponse} Created struct
   */
  static fromObject (other) {
    return new OrderStateSubscribeResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderStateSubscribeResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderStateSubscribeResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderStateSubscribeResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6423
  }
}

export { OrderStateSubscribeResponse };

/**
 * Fast Binary Encoding OrderStateSubscribeResponse field model
 */
class FieldModelOrderStateSubscribeResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.SubscriptionId = new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.OrderIds = new fbe.FieldModelVector(new fbe.FieldModelUInt64(buffer, this.SubscriptionId.fbeOffset + this.SubscriptionId.fbeSize), buffer, this.SubscriptionId.fbeOffset + this.SubscriptionId.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SubscriptionId.fbeSize + this.OrderIds.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SubscriptionId.fbeExtra + this.OrderIds.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderStateSubscribeResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6423
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SubscriptionId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SubscriptionId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SubscriptionId.fbeSize

    if ((fbeCurrentSize + this.OrderIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderIds.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @param {!OrderStateSubscribeResponse} fbeValue Default value, defaults is new OrderStateSubscribeResponse()
   * @returns {!OrderStateSubscribeResponse} OrderStateSubscribeResponse value
   */
  get (fbeValue = new OrderStateSubscribeResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @param {!OrderStateSubscribeResponse} fbeValue OrderStateSubscribeResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SubscriptionId.fbeSize) <= fbeStructSize) {
      fbeValue.SubscriptionId = this.SubscriptionId.get()
    } else {
      fbeValue.SubscriptionId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SubscriptionId.fbeSize

    if ((fbeCurrentSize + this.OrderIds.fbeSize) <= fbeStructSize) {
      this.OrderIds.get(fbeValue.OrderIds)
    } else {
      fbeValue.OrderIds.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderIds.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @param {!OrderStateSubscribeResponse} fbeValue OrderStateSubscribeResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderStateSubscribeResponse}
   * @param {OrderStateSubscribeResponse} fbeValue OrderStateSubscribeResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SubscriptionId.set(fbeValue.SubscriptionId)
    this.OrderIds.set(fbeValue.OrderIds)
  }
}

export { FieldModelOrderStateSubscribeResponse };

/**
 * Fast Binary Encoding OrderStateSubscribeResponse model
 */
class OrderStateSubscribeResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderStateSubscribeResponse(this.buffer, 4)
  }

  /**
   * Get the OrderStateSubscribeResponse model
   * @this {!OrderStateSubscribeResponseModel}
   * @returns {!FieldModelOrderStateSubscribeResponse} model OrderStateSubscribeResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderStateSubscribeResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderStateSubscribeResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderStateSubscribeResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderStateSubscribeResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderStateSubscribeResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderStateSubscribeResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderStateSubscribeResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderStateSubscribeResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderStateSubscribeResponseModel}
   * @param {!OrderStateSubscribeResponse} value OrderStateSubscribeResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderStateSubscribeResponseModel}
   * @param {!OrderStateSubscribeResponse} value OrderStateSubscribeResponse value, defaults is new OrderStateSubscribeResponse()
   * @return {!object} Deserialized OrderStateSubscribeResponse value and its size
   */
  deserialize (value = new OrderStateSubscribeResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderStateSubscribeResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderStateSubscribeResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderStateSubscribeResponseModel}
   * @param {!number} prev Previous OrderStateSubscribeResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderStateSubscribeResponseModel };
